import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { persistor, store } from "./Store/store";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </PersistGate>
  </Provider>
);
